import { configureScrivito } from "app/config/scrivito"

import { configureHistory } from "./configureHistory"
import { configureMenu } from "./configureMenu"
import { configureObjClassForContentType } from "./configureObjClassForContentType"
import { configureScrivitoContentBrowser } from "./scrivitoContentBrowser"
import { configureWindowScrivito } from "./windowScrivito"

export function configureScrivitoEditing() {
  configureScrivito()

  configureMenu()
  configureHistory()
  configureObjClassForContentType()
  configureScrivitoContentBrowser()
  configureWindowScrivito()
}
